import parse from "html-react-parser"
import { DynamicHeadline } from "../../DynamicHeadline"
import { ListItem } from "./ListItem"
import styles from "./Paragraph.module.scss"
import Section, { parseColors } from "../../Section"

export const Paragraph = ({ data = {}, colors, deko_ausblenden = false }) => {
  const {
    dynamic_headline: dynamicHeadline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    list: items,
    numbered_list,
    list_text: listText,
    ankerslug,
  } = data

  const { accent } = parseColors({ colors })

  const ListType = numbered_list ? "ol" : "ul"

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      id={ankerslug}
      colors={colors}
    >
      <DynamicHeadline
        headlineType={headlineType.value}
        headlineAppearance={headlineAppearance.value}
      >
        {dynamicHeadline}
      </DynamicHeadline>
      {listText && <div className={styles.listText}>{parse(listText)}</div>}
      <ListType>
        {items?.length &&
          items.map((item, i) => (
            <ListItem
              key={i}
              item={item}
              order={i + 1}
              type={ListType}
              color={accent.color}
              deko_ausblenden={deko_ausblenden}
            />
          ))}
      </ListType>
    </Section>
  )
}

export default Paragraph
